module.exports = __webpack_public_path__ + "static/media/ios-remove-circle-outline.e5451729.svg";